<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">會員資料管理</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="dialogAdd=true">新增</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isExporting">匯出</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="dialogAuth=true">取得主機授權</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="accountList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="primary"
                  @click="editData(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  @click="openAccountDeleteDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogTitle}}</v-card-title>
          <v-card-text>
            <div class="contentCenter">
              <v-btn-toggle
                v-model="dialogType"
                mandatory
              >
                <v-btn value="basicInfo" class="btn_fontSize">
                  基本資料
                </v-btn>
                <v-btn value="siteInfo" class="btn_fontSize" :disabled="!isEdit">
                  標的物權限
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="contentCenter" v-if="!isEdit">
              <span>請先創建會員再進行其他操作</span>
            </div>
            <div v-show="dialogType==='basicInfo'" class="mt-5">
              <v-form ref="newAccountForm">
                <div class="rowDiv contentCenter">
                  <div style="width:200px">
                    <v-text-field
                      label="會員編號"
                      v-model="selectItem.account_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                      :disabled='isEdit'
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="會員姓名"
                      v-model="selectItem.account_nm"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="登入密碼"
                      v-model="selectItem.account_pwd"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                      type="password"
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2 rowDiv">
                    <v-text-field
                      label="會員照片"
                      v-model="selectItem.account_image"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    >
                    </v-text-field>
                    <v-icon
                      v-if="selectItem.account_image"
                      size = "35"
                      color="success"
                      @click.stop="openImg()"
                    >
                      mdi-magnify
                    </v-icon>
                    <v-icon
                      size = "35"
                      color="green"
                      @click="clickUpload()"
                    >
                      mdi-folder
                    </v-icon>
                    <input type="file" accept="image/*" style="display: none;" ref="fileUpload" @change="getFile">
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="建立時間"
                      v-model="selectItem.create_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="建立人員"
                      v-model="selectItem.create_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="更新時間"
                      v-model="selectItem.update_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="更新人員"
                      v-model="selectItem.update_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
            <div v-show="dialogType==='siteInfo'" class="mt-5">
              <div class="rowDiv">
                <div>
                  <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="dialogSiteAdd=true">新增</v-btn>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="sharePage"
                    :length="sharePageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{shareTotal}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="siteShareInfoList"
                :headers="shareHeaders"
                :items-per-page="10"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in shareHeaders"
                      :key="header.value"
                      class="tableTD"
                    >
                      <div v-if="header.value==='action'">
                        <v-icon
                          size = "35"
                          color="primary"
                          @click="editSiteData(item)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          size = "35"
                          class="ml-2"
                          color="red"
                          @click="openAuthDeleteDialog(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                      <div v-else>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(false)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯標的物權限dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogSiteAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogSiteTitle}}</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newPermissionForm">
                <div class="rowDiv contentCenter">
                  <div style="width:200px">
                    <v-text-field
                      label="標的物"
                      v-model="selectSiteItem.site_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                      :disabled='isSiteEdit'
                    ></v-text-field>
                  </div>
                  <v-icon
                    size = "35"
                    color="green"
                    :disabled='isSiteEdit'
                    @click="dialogSiteIdAdd=true"
                  >
                    mdi-magnify
                  </v-icon>
                  <div style="width:165px" class="ml-2 btn_fontSize">
                    <span>{{selectSiteItem.site_nm}}</span>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-select
                      :items="permissionList"
                      outlined
                      class="rounded-lg"
                      dense
                      v-model="selectSiteItem.PermissionType_ext"
                      hide-details
                      label="權限別"
                      :rules="rules.content"
                    >
                    </v-select>
                  </div>
                  <div style="width:200px" class="ml-2 rowDiv">
                    <v-menu
                      ref="searchExpireDateMenu"
                      v-model="searchExpireDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="selectSiteItem.PermissionExpiredTime"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          class="rounded-lg"
                          dense
                          hide-details
                          label="有效結束日"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="selectSiteItem.PermissionExpiredTime"
                        @input="searchExpireDateMenu = false"
                        no-title
                        scrollable
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="建立時間"
                      v-model="selectSiteItem.create_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="建立人員"
                      v-model="selectSiteItem.create_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="更新時間"
                      v-model="selectSiteItem.update_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="更新人員"
                      v-model="selectSiteItem.update_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeSiteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveSiteData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增標的物dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogSiteIdAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">標的物查詢</v-card-title>
          <v-card-text>
            <div v-show="dialogType==='siteInfo'" class="mt-5">
              <div class="rowDiv">
                <div style="width:200px">
                  <v-text-field
                    label="搜尋"
                    v-model="searchSiteDetail"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="sitePage"
                    :length="sitePageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{siteTotal}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="siteInfoTableList"
                :headers="siteInfoHeader"
                :items-per-page="10"
                height="550"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in siteInfoHeader"
                      :key="header.value"
                      class="tableTD"
                      @click="selectSite(item)"
                    >
                      <div>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn cancelBtnColor" @click="dialogSiteIdAdd=false">關閉</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 取得主機授權dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogAuth" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">取得主機授權</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newAuthForm">
                <div class="rowDiv contentCenter">
                  <div style="width:200px">
                    <v-text-field
                      label="會員編號"
                      v-model="siteAuth.account_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                      :disabled='isEdit'
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="主機編號"
                      v-model="siteAuth.site_mno"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeAuthDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveAuth">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除使用者dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="deleteAccountDialog" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除會員</v-card-title>
          <v-card-text>
            <v-form ref="deleteAccountForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="會員編號"
                    v-model="deleteAccountItem.account_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="會員姓名"
                    v-model="deleteAccountItem.account_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeAccountDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteAccountData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除授權dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="deleteAuthDialog" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除權限</v-card-title>
          <v-card-text>
            <v-form ref="deleteAuthForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="標的物編號"
                    v-model="deleteAuthItem.site_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="標的物名稱"
                    v-model="deleteAuthItem.site_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeAuthDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteAuthData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">會員編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchAccountId"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">會員姓名</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchAccountNm"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Account_Info',
  data: () => ({
    isLoading: false,
    isExporting: false,
    headers: [
      { text: '會員編號', value: 'account_id', sortable: true },
      { text: '會員姓名', value: 'account_nm', sortable: true },
      { text: '', value: 'action', width: '100', sortable: false }
    ],
    shareHeaders: [
      { text: '主機編號', value: 'site_mno', sortable: false },
      { text: '標的物', value: 'site_nm', sortable: false },
      { text: '權限別', value: 'permission_nm', sortable: false },
      { text: '有效結束日', value: 'PermissionExpiredTime', sortable: false },
      { text: '', value: 'action', width: '110', sortable: false }
    ],
    siteInfoHeader: [
      { text: '標的物編號', value: 'site_id', sortable: false },
      { text: '主機編號', value: 'site_mno', sortable: false },
      { text: '標的物名稱', value: 'site_nm', sortable: false },
    ],
    rows: 10,
    sortItem: 'account_id',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    accountList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchAccountId: '',
    searchAccountNm: '',
    siteInfoList: [],
    siteMNOList:[],
    rules: {
      content: [v => !!v || 'Required']
    },
    dialogAdd: false,
    isEdit: false,
    selectItem: {
      AccountType: '0',
      DeviceUID: null,
      account_id: '',
      account_image: null,
      account_nm: '',
      account_notify_id: null,
      account_pwd: '',
      account_uuid: '',
      account_verify: '',
      account_verify_dt: null,
      account_verifycode: '',
      country_code: '886',
      create_dt: '',
      create_user: '',
      enable_notify: 1,
      lang: 'zh-tw',
      phone_num: '',
      sms_seq: '',
      timezone: 8,
      update_dt: '',
      update_user: ''
    },
    selectSiteItem: {
      PermissionExpiredTime: '',
      PermissionType: '',
      PermissionType_ext: 0,
      account_id: '',
      card: null,
      create_dt: '',
      create_user: '',
      role: null,
      site_id: '',
      site_nm: '',
      site_mno: '',
      update_dt: '',
      update_user: ''
    },
    accountImg: null,
    dialogType: 'basicInfo',
    siteShareInfoList: [],
    sharePage: 1,
    sharePageCount: 0,
    shareTotal: 0,
    permissionList: [],
    dialogSiteAdd: false,
    isSiteEdit: false,
    searchExpireDateMenu: false,
    dialogSiteIdAdd: false,
    searchSiteDetail: '',
    siteInfoTableList: [],
    sitePage: 1,
    sitePageCount: 0,
    siteTotal: 0,
    dialogAuth: false,
    siteAuth: {
      account_id: '',
      site_mno: ''
    },
    memberImgChanged: false,

    deleteAccountDialog: false,
    deleteAccountItem: {
      account_id: '',
      account_nm: ''
    },

    deleteAuthDialog: false,
    deleteAuthItem : {
      account_id : '',
      site_id: '',
      site_nm: '',
      PermissionType: '',
      PermissionType_ext: 0,
      PermissionExpiredTime: '',
      card: '',
      role: '',
      create_dt: '',
      create_user: '',
      update_dt: '',
      update_user: '',
    }
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getDictionary()
  },
  watch: {
    page () {
      this.getPageData()
    },
    sharePage () {
      this.getSiteShareInfo()
    },
    sitePage () {
      this.getSiteInfo()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchAccountId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchAccountNm () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteDetail () {
      this.sitePage === 1 ? this.getSiteInfo() : this.sitePage = 1
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    },
    dialogTitle () {
      if (this.isEdit) {
        return '編輯會員'
      } else {
        return '新增會員'
      }
    },
    dialogSiteTitle () {
      if (this.isSiteEdit) {
        return '編輯標的物權限'
      } else {
        return '新增標的物權限'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    getDictionary () {
      var parm = ['site_id(withRemoved)', 'site_mno(withRemoved)', 'permission_definition']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var siteInfoIndex = response.data.map(function (item) { return item.dicNo }).indexOf('site_id(withRemoved)')
            var siteMNOIndex = response.data.map(function (item) { return item.dicNo }).indexOf('site_mno(withRemoved)')
            var permissionIndex = response.data.map(function (item) { return item.dicNo }).indexOf('permission_definition')
            var siteInfoList = response.data[siteInfoIndex].data
            var siteMNOList = response.data[siteMNOIndex].data
            var permissionList = response.data[permissionIndex].data
            siteInfoList.forEach(element => {
              var deviceType = {
                value: element.key,
                text: element.value
              }
              this.siteInfoList.push(deviceType)
            })
            siteMNOList.forEach(element => {
              var mno = {
                value: element.key,
                text: element.value
              }
              this.siteMNOList.push(mno)
            })
            permissionList.forEach(element => {
              var permission = {
                value: Math.pow(2, element.value),
                text: element.key
              }
              this.permissionList.push(permission)
            })
            this.getPageData()
            this.getSiteInfo()
          }
        })
    },
    getPageData () {
      this.isLoading = true
      this.pageCount = 0
      this.accountList = []
      var searchAccountId = {
        name: 'account_id',
        value: this.searchAccountId,
        displayType: 'like'
      }
      var searchAccountNm = {
        name: 'account_nm',
        value: this.searchAccountNm,
        displayType: 'like'
      }
      var wheres = [searchAccountId, searchAccountNm]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'account_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.accountList = response.data.rows
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    exportFile () {
      this.isExporting = true
      var searchAccountId = {
        name: 'account_id',
        value: this.searchAccountId,
        displayType: 'like'
      }
      var searchAccountNm = {
        name: 'account_nm',
        value: this.searchAccountNm,
        displayType: 'like'
      }
      var wheres = [searchAccountId, searchAccountNm]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'account_info/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '會員資料管理.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
    saveData (closeDialog = true) {
      if (this.$refs.newAccountForm.validate()) {
        // console.log(this.selectItem)
        var url = this.isEdit ? '/account_info/update' : '/account_info/Add'
        Service.updateData(this.selectItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              if (this.account_image !== null) {
                if(this.memberImgChanged === true) {
                  this.uploadFile()
                }
              }
              var resp = JSON.parse(response.data.data)
              this.selectItem.account_uuid = resp.data.account_uuid
              this.selectItem.phone_num = resp.data.phone_num
              this.selectItem.create_dt = resp.data.create_dt
              this.selectItem.create_user = resp.data.create_user
              this.selectItem.update_dt = resp.data.update_dt
              this.selectItem.update_user = resp.data.update_user
              
              if (closeDialog) {
                this.closeDialog()
              } else {
                this.editData(this.selectItem)
              }
            }
          })
      }
    },
    saveSiteData () {
      if (this.$refs.newPermissionForm.validate()) {
        
        this.selectSiteItem.PermissionType = (this.selectSiteItem.PermissionType & 0b1111111111111000000) | this.selectSiteItem.PermissionType_ext
        this.selectSiteItem.account_id = this.selectItem.account_id
        // console.log(this.selectSiteItem)
        var url = this.isSiteEdit ? '/site_share_info/update' : '/site_share_info/Add'
        Service.updateData(this.selectSiteItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getSiteShareInfo()
              this.closeSiteDialog()
            }
          })
      }
    },
    clickUpload () {
      this.$refs.fileUpload.click()
    },
    closeDialog () {
      this.isEdit = false
      this.dialogAdd = false
      this.sharePage = 1
      this.dialogType = 'basicInfo'
      if (this.$refs.newAccountForm) {
        this.$refs.newAccountForm.resetValidation()
        this.selectItem = {
          AccountType: '0',
          DeviceUID: null,
          account_id: '',
          account_image: null,
          account_nm: '',
          account_notify_id: null,
          account_pwd: '',
          account_uuid: '',
          account_verify: '',
          account_verify_dt: null,
          account_verifycode: '',
          country_code: '886',
          create_dt: '',
          create_user: '',
          enable_notify: 1,
          lang: 'zh-tw',
          phone_num: '',
          sms_seq: '',
          timezone: 8,
          update_dt: '',
          update_user: ''
        }
      }
      // 暫時特別重取頁面資料
      this.getPageData()
    },
    closeSiteDialog () {
      this.isSiteEdit = false
      this.dialogSiteAdd = false
      if (this.$refs.newPermissionForm) {
        this.$refs.newPermissionForm.resetValidation()
        this.selectSiteItem = {
          PermissionExpiredTime: '',
          PermissionType: '',
          PermissionType_ext: 0,
          account_id: '',
          card: null,
          create_dt: '',
          create_user: '',
          role: null,
          site_id: '',
          update_dt: '',
          update_user: ''
        }
      }
    },
    closeAuthDialog () {
      this.dialogAuth = false
      if (this.$refs.newAuthForm) {
        this.$refs.newAuthForm.resetValidation()
        this.siteAuth = {
          account_id: '',
          site_mno: ''
        } 
      }
    },
    openAccountDeleteDialog (item) {
      this.deleteAccountDialog = true
      this.deleteAccountItem = {
          account_id: item.account_id,
          account_nm: item.account_nm
        }
    },
    closeAccountDeleteDialog () {
      this.deleteAccountDialog = false
      if (this.$refs.deleteAccountForm) {
        this.$refs.deleteAccountForm.resetValidation()
        this.deleteAccountItem = {
          account_id: '',
          account_nm: ''
        }
      }
    },
    deleteAccountData () {
      if (this.$refs.deleteAccountForm) {
        this.$refs.deleteAccountForm.resetValidation()
        
        var deleteList = []
        deleteList.push(this.deleteAccountItem.account_id)
        const url = '/account_info/del'
        Service.deleteData(deleteList, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData()
              this.deleteAccountDialog = false
            }
          })
      }
    },
    openAuthDeleteDialog (item) {
      // console.log(item)
      this.deleteAuthDialog = true
      this.deleteAuthItem = {
        account_id : item.account_id,
        site_id: item.site_id,
        site_nm: item.site_nm,
        PermissionType: item.PermissionType,
        PermissionType_ext: item.PermissionType_ext,
        PermissionExpiredTime: item.PermissionExpiredTime,
        card: item.card,
        role: item.role,
        create_dt: item.create_dt,
        create_user: item.create_user,
        update_dt: item.update_dt,
        update_user: item.update_user,
      }
    },
    closeAuthDeleteDialog () {
      this.deleteAuthDialog = false
      if (this.$refs.deleteAuthForm) {
        this.$refs.deleteAuthForm.resetValidation()
        this.deleteAuthItem = {
          account_id : '',
          site_id: '',
          site_nm: '',
          PermissionType: '',
          PermissionType_ext: 0,
          PermissionExpiredTime: '',
          card: '',
          role: '',
          create_dt: '',
          create_user: '',
          update_dt: '',
          update_user: '',
        }
      }
    },
    deleteAuthData () {
      if (this.$refs.deleteAuthForm) {
        this.$refs.deleteAuthForm.resetValidation()
        
        var url = '/site_share_info/DeleleData'
        Service.updateData(this.deleteAuthItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getSiteShareInfo()
              this.deleteAuthDialog = false
            }
          })
      }
    },
    editData (item) {
      this.selectItem = item
      this.isEdit = true
      this.dialogAdd = true
      this.memberImgChanged = false
      this.getSiteShareInfo()
    },
    editSiteData (item) {
      this.selectSiteItem = item
      this.isSiteEdit = true
      this.dialogSiteAdd = true
    },
    getFile (event) {
      this.memberImgChanged = true;
      this.excLoading = true
      const file = event.target.files
      this.photoImg = file[0]
      this.accountImg = new FormData()
      this.accountImg.append('fileInput', file[0], file[0].name)
      this.selectItem.account_image = file[0].name
    },
    openImg () {
      // console.log(this.selectItem)
      Service.getBase64File('/account_info/getImageFile', this.selectItem.account_image)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            if (response.data.length !== 0) {
              // var filename = this.selectItem.account_image
              // var link = document.createElement('a')
              // link.href = 'data:image/png;base64,' + response.data
              // link.setAttribute('target', '_blank')
              // // link.setAttribute('download', filename)
              // document.body.appendChild(link)
              // link.click()
              // link = null
              
              // source@https://stackoverflow.com/a/58625431/4026100
              let w = window.open('about:blank')
              let image = new Image()
              image.src = 'data:image/png;base64,' + response.data
              setTimeout(function(){
                w.document.write(image.outerHTML)
              }, 0)
            } else {
              this.showAlert('error', '檔案下載失敗，檔案不存在。')
            }
          }
        })
    },
    uploadFile () {
      var url = '/account_info/Upload'
      Service.uploadFile(this.accountImg, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.getPageData()
          }
          this.excLoading = false
          // 清除 input 內的文字，提供相同檔案重複上傳的功能
          this.$refs.fileUpload.value = ''
          this.accountImg = null
        })
    },
    getSiteShareInfo () {
      this.siteShareInfoList = []
      this.sharePageCount = 0
      var searchAccountId = {
        name: 'account_id',
        value: this.selectItem.account_id,
        displayType: '='
      }
      var wheres = [searchAccountId]
      var parm = {
        page: this.sharePage,
        rows: 10,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_share_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.shareTotal = response.data.total
            this.sharePageCount = Math.ceil(this.shareTotal / 10)
            this.siteShareInfoList = response.data.rows
            this.siteShareInfoList.forEach(element => {
              var site = this.siteInfoList.find(x => x.value === element.site_id)
              if (site) {
                element.site_nm = site.text
              }
              element.PermissionType_ext = element.PermissionType & 7
              var permission = this.permissionList.find(x => x.value === element.PermissionType_ext)
              //console.log(element.PermissionType, element.PermissionType & 7, element.PermissionType_ext, this.permissionList, permission)
              if (permission) {
                element.permission_nm = permission.text
              }
              
              var mno = this.siteMNOList.find(x => x.value === element.site_id)
              if (mno) {
                element.site_mno = mno.text
              }
            })
          }
        })
    },
    getSiteInfo () {
      this.siteInfoTableList = []
      this.sitePageCount = 0
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchSiteMno = {
        name: 'site_mno',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchSiteNm = {
        name: 'site_nm',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchType = {
        name: 'FUNCTION',
        value: 'account_info',
        displayType: '='
      }
      var wheres = [searchSiteId, searchSiteMno, searchSiteNm, searchType]
      var parm = {
        page: this.sitePage,
        rows: 10,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.siteTotal = response.data.total
            this.sitePageCount = Math.ceil(this.siteTotal / 10)
            this.siteInfoTableList = response.data.rows
          }
        })
    },
    selectSite (item) {
      this.selectSiteItem.site_id = item.site_id
      this.selectSiteItem.site_nm = item.site_nm
      this.dialogSiteIdAdd = false
    },
    saveAuth () {
      var url = '/site_share_info/SetAuth'
      Service.updateData(this.siteAuth, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.closeAuthDialog()
          }
        })
    }
  }
}
</script>
